import {
  FIRST_LOGIN_ORIGIN_TRACKING_STORAGE_KEY,
  LAST_SIGN_IN_TRACKING_STORAGE_KEY,
} from './tracking.constants'

export function saveSignInTrackingToStorage(timestamp: string): void {
  try {
    localStorage.setItem(LAST_SIGN_IN_TRACKING_STORAGE_KEY, timestamp)
  } catch (e) {
    console.warn('Could not save last sign in tracking timestamp to localStorage', e)
  }
}

export function getSignInTrackingFromStorage(): string | null {
  try {
    return localStorage.getItem(LAST_SIGN_IN_TRACKING_STORAGE_KEY)
  } catch (e) {
    console.warn('Could not get last sign in tracking timestamp from localStorage', e)

    return null
  }
}

export function clearSignInTrackingFromStorage(): void {
  try {
    localStorage.removeItem(LAST_SIGN_IN_TRACKING_STORAGE_KEY)
    sessionStorage.removeItem(FIRST_LOGIN_ORIGIN_TRACKING_STORAGE_KEY)
  } catch (e) {
    console.warn('Could not clear sign in tracking from storage', e)
  }
}

export function saveFirstLoginOriginTrackedToStorage(): void {
  try {
    sessionStorage.setItem(FIRST_LOGIN_ORIGIN_TRACKING_STORAGE_KEY, 'true')
  } catch (e) {
    console.warn('Could not save first login origin tracking to sessionStorage', e)
  }
}

export function hasTrackedFirstLoginOrigin(): boolean {
  try {
    return sessionStorage.getItem(FIRST_LOGIN_ORIGIN_TRACKING_STORAGE_KEY) === 'true'
  } catch (e) {
    console.warn('Could not get first login origin tracking from sessionStorage', e)

    return false
  }
}
